<template>

  <div>

    <h1 v-if="data.title" class="py-8 mb-4">{{ data.title }}</h1>

    <!-- Dont show green collected factors for now! -->
    <!--
    <template v-if="data.factors && data.factors.length">
      <div class="flex flex-wrap mb-8">
        <FactorBadge v-for="factor in data.factors" :key="factor.factorvalueid" :factor="factor" />
      </div>
    </template>
    -->

    <div v-if="wysiwyg" v-html="wysiwyg" class="clearfix mb-8"></div>

    <div v-if="markdown" v-html="markdown" class="clearfix mb-8"></div>


    <!-- DICISION -->
    <template v-if="substate === 'decision'">


      <!-- Buttons -->
      <template v-if="(data.answertype === 'button') && data.answers">

        <VaAnswerButton
          v-for="choice in data.answers"
          :key="choice.action.factornameid"
          :answer="choice"
          :action="choice.action"
          @applyAction="applyAction"
          class="sm:inline-block sm:mr-2"
        ></VaAnswerButton>

      </template>


      <!-- Checkboxes -->
      <template v-if="data.answertype === 'checkbox'">

        <div v-if="data.answers">
          <VaDecisionCheckbox v-for="choice in data.answers" :key="choice.action.factornameid" :answer="choice" :action="data.action"></VaDecisionCheckbox>
        </div>

        <button
          v-if="nextids.length"
          @click.once="applyAction(data.action)"
          class="border-2 border-poly-green mx-auto hover:bg-poly-green hover:text-white"
          style="font-family: Jura; letter-spacing: 2px; font-size: 12px; text-transform: uppercase !important; font-weight: 600; line-height: 20px; opacity: 1; padding: 10px 15px;"
        >Continue</button>

      </template>

    </template>


    <!-- FINDER: Multiple Questions -->
    <template v-else-if="substate === 'finder_question_choose'">

      <VaAnswerButton
        v-if="data.answers"
        v-for="choice in data.answers"
        :key="choice.actions.finder_question.factornameid"
        :answer="choice"
        :action="choice.actions.finder_question"
        @applyAction="applyAction"
        class="mt-6"
        :btnStyle="'background-color:#004f45!important;color:#ffffff!important;'"
      >

        <div v-if="choice.answers">


          <!-- Buttons -->
          <template v-if="choice.answertype === 'button'">

            <div class="flex flex-col sm:flex-row sm:flex-wrap">
              <VaAnswerButton
                v-for="answer in choice.answers"
                :key="answer.text"
                :answer="answer"
                :action="answer.action"
                @applyAction="applyAction"
                class="mr-2"
              ></VaAnswerButton>
            </div>

          </template>


          <!-- Checkboxes -->
          <template v-else-if="choice.answertype === 'checkbox'">

            <div class="flex flex-wrap">
              <VaFinderCheckbox
                v-for="answer in choice.answers"
                :key="answer.action.factorvalueid"
                :answer="answer"
                :action="choice.actions.finder_answers"
                class="w-full sm:w-1/2 md:w-1/3 lg:1/4 mr-8 mb-4"
              ></VaFinderCheckbox>
            </div>

            <button
              v-if="choice.actions.finder_answers.factorvalueids.length"
              @click.once="applyAction(choice.actions.finder_answers)"
              class="inline-block border-2 border-poly-green mx-auto hover:bg-poly-green hover:text-white"
              style="font-family: Jura; letter-spacing: 2px; font-size: 12px; text-transform: uppercase !important; font-weight: 600; line-height: 20px; opacity: 1; padding: 10px 15px;"
            >Next</button>

          </template>

        </div>

      </VaAnswerButton>

    </template>


    <!-- FINDER: One Question -->
    <template v-else-if="substate === 'finder_question_ask'">


      <!-- Buttons -->
      <template v-if="data.answertype === 'button'">

        <div class="flex flex-col sm:flex-row sm:flex-wrap">

          <!-- Answer Button -->
          <VaAnswerButton
            v-for="answer in data.answers"
            :key="answer.text"
            :answer="answer"
            :action="answer.action"
            @applyAction="applyAction"
            class="mr-2"
          ></VaAnswerButton>

          <!-- Skip Button -->
          <VaAnswerButton
            v-if="data.skip"
            :answer="data.skip"
            :action="data.skip.action"
            @applyAction="applyAction"
            class="mr-2"
          ></VaAnswerButton>

        </div>

      </template>


      <!-- Checkboxes -->
      <template v-else-if="data.answertype === 'checkbox'">

        <div class="flex flex-wrap items-start mb-8 pr-8">

          <VaFinderCheckbox
            v-for="answer in data.answers"
            :key="answer.action.factorvalueid"
            :answer="answer"
            :action="data.action"
            class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 mr-8 mb-4"
          ></VaFinderCheckbox>

        </div>

        <!-- IF WE HAVE CHECKED ANSWERS - SHOW "Next ->" BUTTON -->
        <div v-if="singleFinderQuestionHasCheckedAnswers">
          <button
            @click.once="applyAction(data.action)"
            class="border-2 border-poly-green hover:bg-poly-green hover:text-white"
            style="font-family: Jura; letter-spacing: 2px; font-size: 12px; text-transform: uppercase !important; font-weight: 600; line-height: 20px; opacity: 1; padding: 10px 15px;"
          >Next</button>
        </div>

        <!-- ELSE SHOW "I dont know (skip this question)" BUTTON -->
        <VaAnswerButton v-else-if="!singleFinderQuestionHasCheckedAnswers && data.skip"
          :answer="data.skip"
          :action="data.skip.action"
          @applyAction="applyAction"
          class="sm:inline-block sm:mr-2"
        ></VaAnswerButton>

      </template>

    </template>


  </div>

</template>

<script>

import VaAnswerButton from '@/components/VaAnswerButton.vue'
import VaDecisionCheckbox from '@/components/VaDecisionCheckbox.vue'
import VaFinderCheckbox from '@/components/VaFinderCheckbox.vue'
import VaAnswerInfoButton from '@/components/VaAnswerInfoButton.vue'
import VaBackButton from '@/components/VaBackButton.vue'

import FactorBadge from '@/components/FactorBadge.vue'

export default {

  name: 'VaDecision',

  components: {
    VaAnswerButton,
    VaFinderCheckbox,
    VaDecisionCheckbox,
    VaAnswerInfoButton,
    VaBackButton,
    FactorBadge
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {

    singleFinderQuestionHasCheckedAnswers() {
      let answertype     = this.data.answertype  || '';
      let action         = this.data.action      || {};
      let factorvalueids = action.factorvalueids || [];

      return (answertype === 'checkbox') ? !!factorvalueids.length : false;
    },

    nextids() {
      return this.data.action.nextids || [];
    },

    hasImages() {
      if (this.data.answers) {
        return this.data.answers.filter(answer => this.hasImg(answer)).length ? true : false;
      }
      return false;
    },

    substate() {
      return this.data.substate || 'decision';
    },

    answertype() {
      return this.data.answer_type || 'button'; // button, checkbox
    },

    hasSubs() {
      return this.substate === 'finder_question_choose' ? true : false;
    },

    wysiwyg() {
      return this.data.description ? this.data.description.html || '' : '';
    },

    markdown() {
      let data = this.data || {};
      let bm = data.body_markdown || {};
      return bm.html || '';
      // return this.data.body_markdown.markdown ? this.data.body_markdown.html || '' : '';
    }
  },

  methods: {

    hasImg(choice) {
      return choice && choice.img && choice.img.src ? true : false;
    },

    applyAction(params) {
      this.$emit('applyAction', params);
    }
  }

};
</script>

<style lang="scss" scoped>
.body {
  color: #676767;
}
</style>
